import { v4 as uuidv4 } from 'uuid';

export default {
    name: 'review-stars',

    props: {
        numStars: Number,
        // size of stars
        // big = average review score on PDP, review section
        // small = individual review
        // tiny = average review score elsewhere throughout the site
        //      (collections, etc.)
        size: {
            validator(value) {
                // must be one of these strings
                return ['big', 'small', 'tiny'].includes(value);
            },
            default: 'small'
        },
        numReviews: Number,
        numQuestions: Number,
        //allows you to change colors of stars/base with props.
        //ex: Evergreen PLP uses darker grey on lighter grey stars.
        fillColor: {
            default: '#25282A'
        },
        baseColor: {
            default: '#B2B2B2'
        }
    },

    data() {
        return {
            starStyle: {
                width:
                    this.size === 'big'
                        ? '25px'
                        : this.size === 'small'
                        ? '16px'
                        : '10px',
                height:
                    this.size === 'big'
                        ? '24px'
                        : this.size === 'small'
                        ? '15px'
                        : '9px'
            },
            uuid: ''
        };
    },
    computed: {
        partial() {
            // get partial part of score (eg. 0.7 for 4.7)
            // multiply by 100 for use as percentage in SVG gradient
            return Math.floor(
                (this.numStars - Math.floor(this.numStars)) * 100
            );
        },
        starOne() {
            if (this.numStars >= 1) {
                return this.fillColor;
            } else {
                return `url(#${this.uuid}-partial)`;
            }
        },
        starTwo() {
            if (this.numStars >= 2) {
                return this.fillColor
            } else if (this.numStars < 1) {
                return this.baseColor;
            } else {
                return `url(#${this.uuid}-partial)`;
            }
        },
        starThree() {
            if (this.numStars >= 3) {
                return this.fillColor;
            } else if (this.numStars < 2) {
                return this.baseColor;
            } else {
                return `url(#${this.uuid}-partial)`;
            }
        },
        starFour() {
            if (this.numStars >= 4) {
                return this.fillColor;
            } else if (this.numStars < 3) {
                return this.baseColor;
            } else {
                return `url(#${this.uuid}-partial)`;
            }
        },
        starFive() {
            if (this.numStars === 5) {
                return this.fillColor;
            } else if (this.numStars < 4) {
                return this.baseColor;
            } else {
                return `url(#${this.uuid}-partial)`;
            }
        }
    },
    created() {
        // create unique id for each review stars component
        this.uuid = uuidv4();
    }
};
